// General
import { gsap, Power4 } from 'gsap'

import { ready } from './lib/utils/utils'

// Stimulus.js and controllers
import { Application } from 'stimulus';
import ExpandableController from './lib/controllers/expandable-controller';
import NavMainSubMenuController from './lib/controllers/nav-main-sub-menu-controller';
import HeaderController from './lib/controllers/header-controller';
import SearchFieldController from './lib/controllers/search-field-controller';
import AccordionController from './lib/controllers/accordion-controller';
import AccordionItemController from './lib/controllers/accordion-item-controller';
import DisruptorController from './lib/controllers/disruptor-controller';
import KeyvisualController from './lib/controllers/keyvisual-controller';
import PhoenixDumbellController from './lib/controllers/phoenix-dumbell-controller';

// Setup functions
import { SetupInViewDetection } from './lib/bootstrap/setup-in-view-detection';
import { SetupAnchorScrollTo } from './lib/bootstrap/setup-anchor-scroll-to';
import { SetupSwiper } from './lib/bootstrap/setup-swiper';
import { SetupLightbox } from './lib/bootstrap/setup-lightbox';
import { SetupIsScrolledDetector } from './lib/bootstrap/setup-is-scrolled-detector';

gsap.defaults({
  ease: Power4.easeInOut,
  duration: 0.35
});

ready(function () {

  var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
  if (isIE11) document.body.classList.add("-is-ie-11");

  // Stimulus.js and controllers
  const application = Application.start();
  application.register('expandable', ExpandableController);
  application.register('nav-main-sub-menu', NavMainSubMenuController);
  application.register('header', HeaderController);
  application.register('search-field', SearchFieldController);
  application.register('accordion', AccordionController);
  application.register('accordion-item', AccordionItemController);
  application.register('disruptor', DisruptorController);
  application.register('keyvisual', KeyvisualController);
  application.register('phoenix-dumbell', PhoenixDumbellController);

  // Setup functions
  SetupInViewDetection();
  SetupAnchorScrollTo(250);
  SetupSwiper();
  SetupLightbox();
  SetupIsScrolledDetector();

});